// RSchemaView: synchronous accessors over a resolved SchemaState.
//
// All DAG access happens when the view is built (RSchemaImpl resolves and
// caches the state per version); the view itself is a pure reader.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DEFAULT_CONCURRENT_DELETES, defaultRestrictionRule, } from "./payload.js";
export class RSchemaViewImpl {
    constructor(target, state, at, from) {
        this.target = target;
        this.state = state;
        this.at = at;
        this.from = from;
    }
    getObject() {
        return this.target;
    }
    getVersion() {
        return this.at;
    }
    getFromVersion() {
        return this.from;
    }
    getReferences() {
        return __awaiter(this, void 0, void 0, function* () {
            return [];
        });
    }
    resolveRefVersion(_refId) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error("RSchema holds no references");
        });
    }
    // Immutable create-time facts
    getName() {
        return this.state.name;
    }
    getCreators() {
        return this.state.creators;
    }
    isCreator(keyId) {
        return this.state.creators.some((c) => c.keyId === keyId);
    }
    // The effective table set
    getTableNames() {
        return [...this.state.tables.keys()];
    }
    hasTable(name) {
        return this.state.tables.has(name);
    }
    getTable(name) {
        return this.state.tables.get(name);
    }
    requireTable(name) {
        const def = this.state.tables.get(name);
        if (def === undefined) {
            throw new Error(`Table '${name}' does not exist at this version`);
        }
        return def;
    }
    // Per-slot accessors with defaults applied
    getConcurrentDeletes(table) {
        var _a;
        return (_a = this.requireTable(table).concurrentDeletes) !== null && _a !== void 0 ? _a : DEFAULT_CONCURRENT_DELETES;
    }
    getFKs(table) {
        var _a;
        return (_a = this.requireTable(table).fks) !== null && _a !== void 0 ? _a : {};
    }
    getRestriction(table, op) {
        var _a;
        const def = this.requireTable(table);
        const matching = ((_a = def.restrictions) !== null && _a !== void 0 ? _a : [])
            .filter((r) => r.on === op || r.on === 'all')
            .map((r) => r.rule);
        if (matching.length === 0)
            return defaultRestrictionRule(op);
        if (matching.length === 1)
            return matching[0];
        return { p: 'and', args: matching };
    }
    getPubColumns(table) {
        const def = this.requireTable(table);
        return Object.keys(def.columns).filter((c) => { var _a; return (_a = def.columns[c].pub) !== null && _a !== void 0 ? _a : false; });
    }
    getIdProvider(table) {
        var _a;
        return (_a = this.state.tables.get(table)) === null || _a === void 0 ? void 0 : _a.idProvider;
    }
    getColumnIncarnation(table, column) {
        var _a;
        return (_a = this.state.columnIncarnations.get(table)) === null || _a === void 0 ? void 0 : _a.get(column);
    }
}
